import {
  SET_TEMPLATES_LOADING,
  SET_TEMPLATES_ERROR,
  SET_SHIPMENT_TEMPLATES,
  SET_BULK_TEMPLATES,
  SET_DEAL_TEMPLATES,
} from "./mutation-types";

export default {
  [SET_TEMPLATES_LOADING](state, loading) {
    state.isLoading = loading;
  },

  [SET_TEMPLATES_ERROR](state, error) {
    state.error = error;
  },

  [SET_SHIPMENT_TEMPLATES](state, templates) {
    state.shipmentTemplates = templates;
  },

  [SET_BULK_TEMPLATES](state, templates) {
    state.bulkTemplates = templates;
  },

  [SET_DEAL_TEMPLATES](state, templates) {
    state.dealTemplates = templates;
  },
};
